import React from 'react'
import {Form, message, Upload} from 'antd'
import {baseUrl, reqFileDel} from '../../api';

export default function PhotoFileFormItem(props) {
    const {getFieldDecorator, label, name, initialValue, required, fileType, orderId, readOnly} = props;
    const handleRemove = file => {
        return delFile(file);
    }
    const delFile = (file) => {
        return new Promise(async (resolve, reject) => {
            let obj = {};
            obj.orderId = orderId;
            obj.fileId = file.id ? file.id : file.response.data.id;
            const result = await reqFileDel(obj);
            if (result.code === 200) {
                return resolve(true)
            } else {
                message.error(result.message);
                return reject()
            }
        })
    }
    const handleBeforeUpload = (f, fList) => {
        return new Promise((resolve, reject) => {
            if (f.size / 1024 / 1024 > 2) {
                message.info("只能上传2M内的图片");
                return reject(false);
            }
            //限制上传类型
            const typeImg = ["gif", "png", "jpg", "jpeg"];
            const type = f.name.indexOf(".") != -1 ? f.name.substring(f.name.lastIndexOf(".") + 1, f.name.length).toLowerCase() : null;
            if (type.includes('image/') || !typeImg.includes(type)) {
                message.info("不支持该文件类型,支持gif,png,jpg,jpeg格式");
                return reject(false);
            }
            return resolve(true);
        });
    }
    const normFile = e => {
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList;
    };
    return (<Form.Item label={label}>
            {getFieldDecorator(name, {
                valuePropName: 'fileList',
                getValueFromEvent: normFile,
                rules: [{required: required, message: '该项必填'}],
                initialValue: initialValue,
            })(<Upload
                    showUploadList={{
                        showDownloadIcon: false,
                        showRemoveIcon: !readOnly
                    }}
                    action={baseUrl + '/api/v1/p/file/upLoad?objectType=' + fileType + '&orderId=' + (orderId ? orderId : '')}
                    listType='picture-card'
                    withCredentials={true}
                    onRemove={handleRemove}
                    beforeUpload={handleBeforeUpload}>
                    {!readOnly && <div className="ant-upload-text">上传</div>}
                </Upload>
            )}
        </Form.Item>
    )
}